import { __assign, __read } from "tslib";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import * as MuiIcon from '@mui/icons-material';
import { IconNameTypes } from './iconDict';
var Default = function (props) {
    var iconName = props.iconName, opacity = props.opacity;
    if (iconName === undefined ||
        iconName === null ||
        iconName === "") {
        return (_jsx(_Fragment, { children: "Icon Name is undefined or null." }));
    }
    if (!IconNameTypes.includes(iconName)) {
        return (_jsx(_Fragment, { children: "Icon Name is not valid." }));
    }
    var iconStyle = {
        fontSize: '16px',
        opacity: opacity,
    };
    var Icon = MuiIcon[iconName];
    return (_jsx(Icon, { style: iconStyle }));
};
var ToButton = function (props) {
    var id = props.id, iconName = props.iconName, opacity = props.opacity, onClick = props.onClick;
    var _a = __read(React.useState(1), 2), varOpacity = _a[0], setVarOpacity = _a[1];
    var customStyle = {
        display: 'flex',
        width: 'atuo',
        height: 'auto',
        cursor: 'pointer',
        opacity: varOpacity,
        transition: 'opacity 0.1s ease',
    };
    var MuiIconWrapper = MuiIcon[iconName];
    return (_jsx("div", { id: id, style: customStyle, onMouseOver: function () { return setVarOpacity(0.5); }, onMouseOut: function () { return setVarOpacity(1); }, onMouseDown: function () { return setVarOpacity(0.2); }, onMouseUp: function () { return setVarOpacity(0.5); }, onClick: onClick, children: _jsx(MuiIconWrapper, { sx: {
                fontSize: '16px',
                opacity: opacity,
            } }) }));
};
var StyledComponent = styled(function (props) {
    var toButton = props.toButton;
    if (toButton) {
        return _jsx(ToButton, __assign({}, props));
    }
    return _jsx(Default, __assign({}, props));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
export default ThemedComponent;
